export default {
    section: 'Consulting Support',
    name: 'offer-letter-consulting-support',
    items: [
        {
            type: 'inline',
            text: 'Consulting Timeframe',
            items: [
                {
                    type: 'text-field',
                    name: 'offer-letter-consulting-support-time-duration',
                    width: 3,
                    props: {
                        label: 'Duration',
                        format: 'number'
                    }
                },
                {
                    type: 'selectlist',
                    name: 'offer-letter-consulting-support-time-units',
                    width: 3,
                    props: {
                        items: [
                            {
                                text: 'Months',
                                value: 'months'
                            },
                            {
                                text: 'Years',
                                value: 'years'
                            }
                        ]
                    }
                }
            ],
            subItems: [
                {
                    type: 'text-field',
                    text: 'Up to',
                    name: 'offer-letter-consulting-support-first-hours',
                    width: 3,
                    props: {
                        label: 'Hours',
                        format: 'number'
                    }
                },
                {
                    type: 'inline',
                    text: 'For the First',
                    items: [
                        {
                            type: 'text-field',
                            name: 'offer-letter-consulting-support-first-duration',
                            width: 3,
                            props: {
                                label: 'Duration',
                                format: 'number'
                            }
                        },
                        {
                            type: 'selectlist',
                            name: 'offer-letter-consulting-support-first-units',
                            width: 3,
                            props: {
                                items: [
                                    {
                                        text: 'Months',
                                        value: 'months'
                                    },
                                    {
                                        text: 'Years',
                                        value: 'years'
                                    }
                                ]
                            }
                        }
                    ]
                },
                {
                    type: 'text-field',
                    text: 'Up to',
                    name: 'offer-letter-consulting-support-second-hours',
                    width: 3,
                    props: {
                        label: 'Hours',
                        format: 'number'
                    }
                },
                {
                    type: 'inline',
                    text: 'For the Second',
                    items: [
                        {
                            type: 'text-field',
                            name: 'offer-letter-consulting-support-second-duration',
                            width: 3,
                            props: {
                                label: 'Duration',
                                format: 'number'
                            }
                        },
                        {
                            type: 'selectlist',
                            name: 'offer-letter-consulting-support-second-units',
                            width: 3,
                            props: {
                                items: [
                                    {
                                        text: 'Months',
                                        value: 'months'
                                    },
                                    {
                                        text: 'Years',
                                        value: 'years'
                                    }
                                ]
                            }
                        }
                    ]
                },
                {
                    type: 'text-field',
                    text: 'Up to',
                    name: 'offer-letter-consulting-support-third-hours',
                    width: 3,
                    props: {
                        label: 'Hours',
                        format: 'number'
                    }
                },
                {
                    type: 'inline',
                    text: 'For the Third',
                    items: [
                        {
                            type: 'text-field',
                            name: 'offer-letter-consulting-support-third-duration',
                            width: 3,
                            props: {
                                label: 'Duration',
                                format: 'number'
                            }
                        },
                        {
                            type: 'selectlist',
                            name: 'offer-letter-consulting-support-third-units',
                            width: 3,
                            props: {
                                items: [
                                    {
                                        text: 'Months',
                                        value: 'months'
                                    },
                                    {
                                        text: 'Years',
                                        value: 'years'
                                    }
                                ]
                            }
                        }
                    ]
                }
            ]
        }
    ]
};


// WEBPACK FOOTER //
// ./src/components/offer-letter/valuation-data/consulting-support.js